export const REFUND='REFUND'
export const REFUND_SUCCESS='REFUND_SUCCESS'
export const REFUND_ERROR='REFUND_ERROR'

export const Refund = (data) => ({
    type: REFUND,
    payload: data
})